import React, { useState } from 'react';
import { Tooltip } from 'react-tooltip';
import '../styles/RankedChoiceVoting.css';
import alaskaIcon from '../assets/cool-alaska-icon-image.jpg';

const RankedChoiceVoting = () => {
    const [showSidebar, setShowSidebar] = useState(false);

    const toggleSidebar = () => {
        setShowSidebar(prev => !prev);
    };

    return (
        <div className="rcv-page">

            {/* --- Floating Ribbon Button --- */}
            <div className="ribbon-container" onClick={toggleSidebar}>
                <div className="ribbon-text">Fun Facts</div>
                <div
                    className={`ribbon-arrow ${showSidebar ? 'rotate-left' : 'rotate-right'}`}
                    dangerouslySetInnerHTML={{ __html: '&#10148;' }}
                />
            </div>

            {/* --- Card Row (Sidebar + Main Card) --- */}
            <div className={`card-row ${showSidebar ? 'expanded' : ''}`}>

                {/* Sidebar */}
                {showSidebar && (
                    <div className="side-card">
                        <h3 className="fun-facts-header">RCV Fun Facts</h3>

                        <p><strong>Origins:</strong> Ranked Choice Voting (RCV) dates back to the 1850s, first used in Denmark and Tasmania for parliamentary elections.</p>

                        <p><strong>First in the U.S.:</strong> Cambridge, Massachusetts has used RCV for city council and school board elections since 1941.</p>

                        <p><strong>Alaska Adoption:</strong> Alaska adopted RCV through Ballot Measure 2 in November 2020. It was first implemented in the 2022 elections for statewide and federal offices.</p>

                        <p><strong>Other U.S. Cities:</strong> New York City, San Francisco, Minneapolis, and several other cities use RCV for mayoral and local elections.</p>

                        <p><strong>International:</strong> RCV (or variants of it) is used in countries such as Australia (House of Representatives elections), Ireland (presidential and parliamentary elections), and Scotland (local council elections).</p>

                        <p><strong>Majority Wins:</strong> In RCV systems, winners must secure a majority (more than 50%) of active votes in the final round, rather than just a simple plurality.</p>

                        <p><strong>Military Use:</strong> Alabama, Arkansas, Louisiana, Mississippi, South Carolina, and Springfield, Illinois use RCV for military and overseas absentee voters to simplify runoff elections.</p>

                        <p><strong>Maine Usage:</strong> Maine became the first U.S. state to use RCV for federal elections, including for the presidency, starting in 2020.</p>

                        <p><strong>Overseas Absentee Ballots:</strong> RCV allows military and overseas voters in several states to rank candidates in advance in case of runoff elections, ensuring their ballot remains valid without needing a second vote.</p>

                        <p><strong>Alaska’s First RCV Election:</strong> The 2022 special election to replace Congressman Don Young was the first statewide RCV election in Alaska history.</p>

                        <div className="important-links">
                            <h3 className="learn-more-header">Learn More</h3>
                            <ul className="alaska-icon-links">
                                <li>
                                    <a href="https://www.elections.alaska.gov/election-information/#RankedChoice" target="_blank" rel="noopener noreferrer" className="alaska-icon-button blue-overlay">
                                        <span>Alaska Election Info</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.elections.alaska.gov/election-results/" target="_blank" rel="noopener noreferrer" className="alaska-icon-button green-overlay">
                                        <span>Election Results</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.elections.alaska.gov/sample-ballots/ballot/24genr2/" target="_blank" rel="noopener noreferrer" className="alaska-icon-button orange-overlay">
                                        <span>Sample Ballot</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.congress.gov/crs_external_products/LSB/HTML/LSB10837.web.html" target="_blank" rel="noopener noreferrer" className="alaska-icon-button purple-overlay">
                                        <span>Federal RCV Overview</span>
                                    </a>
                                </li>
                            </ul>
                        </div>

                    </div>

                )}

                {/* Main RCV Card */}
                <div className="rcv-card">
                    <h2>Alaska Ranked Choice Voting</h2>

                    <p className="welcome-subtext">
                        In accordance with Alaska law, all general elections will be conducted by Ranked Choice Voting (RCV). RCV allows voters to rank candidates in order of preference. Only the top four candidates who received the greatest number of votes for any office in the primary will appear on the general election ballot. There will still be a space for write-in candidates except for Presidential races. For a candidate to win, they must receive a majority (50% + 1) of total votes cast. If no candidate receives a majority of 1st choice votes in the 1st round of counting, more rounds of counting continue until a candidate reaches a majority.
                    </p>

                    <p className="intro-text">
                        This new system was first used in Alaska's 2022 elections and marked a historic shift in how Alaskans vote.
                        RCV is also utilized internationally in countries like Australia, Ireland, and Scotland, and is growing in use across U.S. cities and states.
                    </p>

                    <p className="intro-text">
                        To learn more about how Ranked Choice Voting works in Alaska, view official election information, and see live results from past elections, check out our fun facts!.
                    </p>


                    {/*<h3>Key Features of RCV</h3>*/}
                    {/*<ul className="rcv-links">*/}
                    {/*    <li>*/}
                    {/*        <a href="https://www.elections.alaska.gov/election-information/#RankedChoice" target="_blank" rel="noopener noreferrer" data-tooltip-id="rcv-tooltip" data-tooltip-content="Learn more about how RCV works in Alaska">*/}
                    {/*            How RCV Works*/}
                    {/*        </a>*/}
                    {/*    </li>*/}
                    {/*    <li>*/}
                    {/*        <a href="https://www.elections.alaska.gov/election-results/" target="_blank" rel="noopener noreferrer" data-tooltip-id="rcv-tooltip" data-tooltip-content="Alaska Elections Department Election results page">*/}
                    {/*            Official Summary Results*/}
                    {/*        </a>*/}
                    {/*    </li>*/}
                    {/*    <li>*/}
                    {/*        <a href="https://www.elections.alaska.gov/election-results/e/" target="_blank" rel="noopener noreferrer" data-tooltip-id="rcv-tooltip" data-tooltip-content="2024 General Election">*/}
                    {/*            2024 General Election Results*/}
                    {/*        </a>*/}
                    {/*    </li>*/}
                    {/*</ul>*/}

                    {/*<h3>Explore RCV Visuals</h3>*/}
                    {/*<p className="image-caption">Learn more about Ranked Choice Voting through official infographics and sample ballots.</p>*/}

                    {/*<div className="featured-image-square">*/}
                    {/*    <a href="https://www.elections.alaska.gov/election-information/#RankedChoice" target="_blank" rel="noopener noreferrer">*/}
                    {/*        <img src="https://www.elections.alaska.gov/wp-content/uploads/2023/10/RCV-Rack-Card-Distribution_Page_1-455x1024.jpg" alt="RCV Infographic" data-tooltip-id="rcv-tooltip" data-tooltip-content="View the official RCV infographic" />*/}
                    {/*    </a>*/}
                    {/*</div>*/}

                    {/*<div className="featured-image-wide" style={{ marginTop: '20px' }}>*/}
                    {/*    <a href="https://www.elections.alaska.gov/sample-ballots/ballot/24genr2/" target="_blank" rel="noopener noreferrer">*/}
                    {/*        <img src="https://www.elections.alaska.gov/img/ballot_ex-correct.png" alt="RCV Ballot Example" data-tooltip-id="rcv-tooltip" data-tooltip-content="See an example of an RCV ballot" />*/}
                    {/*    </a>*/}
                    {/*</div>*/}
                </div>
            </div>

            <Tooltip id="rcv-tooltip" />
        </div>
    );
};

export default RankedChoiceVoting;
